import React from 'react';
import SIcon from './SIcon';
import { faArrowCircleUp } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faArrowCircleUp} fa />;

export default Icon;
